import React, { Component } from 'react';
import SidebarMenuItem, { SidebarMenuItemProps } from './SidebarMenuItem';

class SidebarMenuItemContainer extends Component<Props> {
  public render() {
    const { items, goPage, pathName, collapsed, title, collapsedTitle } = this.props;
    return (
      <div className={'flex flex-col w-full items-center'}>
        <div className={'flex items-center w-full h-10 gap-x-1'}>
          <p className={`text-f-black-4 font-bold tracking-[1.5px] ${collapsed ? 'text-center w-full' : 'ml-5'} text-sm`}>
            {collapsed ? collapsedTitle : title}
          </p>
        </div>
        {items.map((m) => (
          <SidebarMenuItem key={m.name} item={m} goPage={goPage} pathName={pathName} collapsed={collapsed} />
        ))}
      </div>
    );
  }
}

interface Props {
  items: SidebarMenuItemProps[];
  goPage(item: SidebarMenuItemProps): void;
  pathName: string;
  collapsed: boolean;
  title: string;
  collapsedTitle: string;
}

export default SidebarMenuItemContainer;
